import { CreditsBasedTierEnum } from '~/generated/graphql';

const legacySelfServePlans = [
  CreditsBasedTierEnum.FreeTier,
  CreditsBasedTierEnum.PaidTier,
];

const hubspotSelfServePlans = [
  CreditsBasedTierEnum.HubspotFreeTier,
  CreditsBasedTierEnum.HubspotPaidTier,
];

export const plans = (isHubspotAccount: boolean) => {
  if (isHubspotAccount) {
    return hubspotSelfServePlans;
  } else {
    return legacySelfServePlans;
  }
};

export const growthPlan = (isHubspotAccount: boolean) => {
  if (isHubspotAccount) {
    return CreditsBasedTierEnum.HubspotPaidTier;
  } else {
    return CreditsBasedTierEnum.PaidTier;
  }
};

export const planLimits = {
  [CreditsBasedTierEnum.FreeTier]: [500],
  [CreditsBasedTierEnum.PaidTier]: [1000, 1500, 2000],
  [CreditsBasedTierEnum.HubspotFreeTier]: [25],
  [CreditsBasedTierEnum.HubspotPaidTier]: [125, 250, 500, 750, 1000],
};

export const legacyPaidTierLimitToPriceMap = {
  1000: 299,
  1500: 559,
  2000: 749,
};

export const hubspotPaidTierLimitToPriceMap = {
  125: 50,
  250: 75,
  500: 150,
  750: 225,
  1000: 275,
};

export const creditOptions = (isHubspotAccount: boolean) => {
  const pricingTiers = isHubspotAccount
    ? hubspotPaidTierLimitToPriceMap
    : legacyPaidTierLimitToPriceMap;
  return Object.keys(pricingTiers).map((keyString) => {
    const key = parseInt(keyString, 10); // parse the key back into a number

    return {
      value: keyString,
      credits: key,
      cost: pricingTiers[key as keyof typeof pricingTiers],
    };
  });
};
